import { Subject } from 'rxjs'

export const RubberbandStatus = new Subject<boolean>()
